module.exports = __webpack_public_path__ + "static/media/main-image-2.c08ce1a2.png";